import type { InputConfig, ButtonRect } from "./config";
import type {
  InputSample,
  DodgeAction,
  BlockAction,
  InputListener,
} from "./types";

export class ButtonInput {
  private listener: InputListener | null = null;
  private config: InputConfig;
  private nowTick: () => number;
  private activeButtons = new Map<number, "dodge" | "block">(); // pointerId -> button type

  constructor(config: InputConfig, nowTick: () => number) {
    this.config = config;
    this.nowTick = nowTick;
  }

  onInput(listener: InputListener): void {
    this.listener = listener;
  }

  setRects(dodge: ButtonRect, block: ButtonRect): void {
    this.config.dodgeButton = dodge;
    this.config.blockButton = block;
  }

  processSample(sample: InputSample): boolean {
    const { pointerId, phase, x, y } = sample;

    if (phase === "start") {
      // Check if touch started on a button
      if (this.isInRect(x, y, this.config.dodgeButton)) {
        this.activeButtons.set(pointerId, "dodge");
        this.emitDodge();
        return true;
      } else if (this.isInRect(x, y, this.config.blockButton)) {
        this.activeButtons.set(pointerId, "block");
        this.emitBlock();
        return true;
      }
    } else if (phase === "end" || phase === "cancel") {
      const wasButton = this.activeButtons.has(pointerId);
      this.activeButtons.delete(pointerId);
      return wasButton;
    }

    return this.activeButtons.has(pointerId);
  }

  private isInRect(x: number, y: number, rect: ButtonRect): boolean {
    return (
      x >= rect.x &&
      x <= rect.x + rect.width &&
      y >= rect.y &&
      y <= rect.y + rect.height
    );
  }

  private emitDodge(): void {
    if (this.listener) {
      const action: DodgeAction = {
        type: "dodge",
        direction: "left", // TODO: determine from game state
        tick: this.nowTick(),
      };
      this.listener(action);
    }
  }

  private emitBlock(): void {
    if (this.listener) {
      const action: BlockAction = {
        type: "block",
        tick: this.nowTick(),
      };
      this.listener(action);
    }
  }
}
